import { render, staticRenderFns } from "./DonutChartCard.vue?vue&type=template&id=23beed48&scoped=true"
import script from "./DonutChartCard.vue?vue&type=script&lang=js"
export * from "./DonutChartCard.vue?vue&type=script&lang=js"
import style0 from "./DonutChartCard.vue?vue&type=style&index=0&id=23beed48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23beed48",
  null
  
)

export default component.exports